import { Styler } from '@honeycomb/ui-core';
import React from 'react';
export function VideoPlayer({ videoUrl }) {
    return (React.createElement(Styler, { aspectRatio: "16/9", component: "iframe", w: "100%", h: "100%", va: "middle", src: videoUrl, frameBorder: "0", allow: "autoplay", allowscriptaccess: "always", allowfullscreen: "" }));
}
